import toastr from "toastr";
import errorMixin from "mixins/errorMixin";
import {mapActions, mapGetters} from "vuex";

const productAmount = function (amount = 0) {
    const split = amount.toString().split('.');
    if (split[1] && +split[1] > 0) {
        return amount;
    }
    return split[0];
}

export default {
    props: {
        product: {
            type: Object,
            require: true,
        },
    },
    components: {
        ShippingMethod: () => import('components/product/shipping/ShippingMethod'),
    },
    mixins: [errorMixin],
    data() {
        return {
            canAddToCart: true,
            selected_variants: {...this.product.show_variants},
            quantity: 1,
        };
    },
    computed: {
        ...mapGetters("shipping", ["getCountryId"]),
        ...mapGetters("cart", ["getCartItems", "getCartItemById", "getCartDraftItemById"]),
        isWishListed() {
            return this.$store.state.wishlist.items.find(i => +i.id === +this.product.id)?.isWishListed;
        },
        selected_item() {
            let prices = {
                name: this.product.name,
                item_unique_id: this.product.item_unique_id,
                sku: this.product.sku,
                price: this.product.price,
                old_price: this.product.old_price,
                stock_quantity: +this.product.stock_quantity,
            };
            for (const [index, variant] of this.product.variants.entries()) {
                let isSelected = true;
                for (let i = 1; i <= 3; i++) {
                    if (typeof this.selected_variants[variant['opt' + i + '_name']] === 'undefined' || this.selected_variants[variant['opt' + i + '_name']] === variant['opt' + i + '_value']) {
                        continue;
                    }
                    isSelected = false;
                    break;
                }
                if (isSelected) {
                    const ids = this.product.item_unique_id.split('_');
                    ids[ids.length - 1] = variant.id;
                    const item_id = variant.original_product_variant_id || variant.id;
                    const skus = [];
                    this.product.variant_skus.forEach(i => {
                        if (i.product_variant_id === variant.id) {
                            skus.push(i.sku);
                        }
                    });
                    prices = {
                        name: `${this.product.name} (${variant.name})`,
                        item_unique_id: ids.join('_'),
                        sku: skus.length > 0 ? skus.join(', ') : 'N/A',
                        variant_id: variant.id,
                        price: variant.price,
                        old_price: variant.old_price,
                        stock_quantity: +variant.stock_quantity,
                    };
                    break;
                }
            }
            this.determineStockCheck(prices);
            return prices;
        },
        isLocalShipping() {
            return +this.product.original_country_id === +this.getCountryId;
        },
    },
    mounted() {
        for (const variant in this.product.show_variants) {
            const firstItem = Object.values(this.product.show_variants[variant])[0];
            this.selected_variants[variant] = firstItem.value;
        }
        this.renderShareOnFacebook();
        if (this.product.isWishListed) {
            this.pushToWishList(this.product)
        }

        $("#zoom_01").ezPlus({
            containLensZoom: true, gallery: 'gallery_01', cursor: 'pointer', galleryActiveClass: 'active'
        });
    },
    methods: {
        ...mapActions("cart", ["setCartItems", "addToCartItems", "addToDraftItems"]),
        ...mapActions("wishlist", ["addToWishList", "pushToWishList"]),
        productAmount,
        renderShareOnFacebook() {
            (function (d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            const fbButton = document.getElementById('fb-share-button');
            if (fbButton) {
                fbButton.addEventListener('click', function () {
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
                        'facebook-share-dialog',
                        'width=800,height=600'
                    );
                    return false;
                });
            }
        },
        updateQuantity(operator) {
            if (operator === 'plus') {
                if (this.product.check_stock_during_add_to_cart && this.quantity === +this.selected_item.stock_quantity) {
                    toastr.error('You can add maximum ' + this.quantity + ' quantity');
                } else {
                    this.quantity += 1;
                }
            } else if (operator === 'minus' && this.quantity === 1) {
                toastr.error('You must add minimum 1 quantity');
            } else if (operator === 'minus' && this.quantity > 1) {
                this.quantity -= 1;
            }
        },
        determineStockCheck(variant) {
            this.resetErrors();
            if (variant.stock_quantity > 0) {
                this.canAddToCart = true;
            } else {
                // this.addError('Stock Out');
                this.canAddToCart = false;
            }
        },
        addToCart() {
            if (!this.canAddToCart) {
                toastr.error('Can not add to cart!');
                return;
            }
            this.resetErrors();
            let draftItem = {...this.getCartDraftItemById(this.selected_item.item_unique_id)};
            if (!Object.keys(draftItem).length > 0) {
                this.addToDraftItems({...this.product, ...this.selected_item, local_delivery: null});
                draftItem = {...this.getCartDraftItemById(this.selected_item.item_unique_id)};
            }

            /**
             * ********************************************
             *  check unique key
             * ********************************************
             */
            if (!this.selected_item.item_unique_id) {
                alert('something went wrong')
                return;
            }

            /**
             * ********************************************
             *  validation start
             * ********************************************
             */
            let flag = true;
            // if ('raw_variants' in product) {
            //     if (product.raw_variants.length> 0 && (selected_variant === null && (selected_variant.value ==="" || selected_variant.value === null))) {
            //         errorLists.appendChild(createError('you have to select a variant'))
            //         flag = false
            //     }
            // }

            if (this.isLocalShipping && this.product.local_shipping.length > 0 && !draftItem.local_delivery) {
                this.addError('Select delivery method');
            }
            if (!this.isLocalShipping && !draftItem.international_delivery) {
                this.addError('Select delivery method');
            }

            if (this.errors.length > 0) {
                return;
            }
            /**
             * ********************************************
             *  validation end
             * ********************************************
             */

            draftItem.quantity = this.quantity;
            this.addToCartItems(draftItem);
        },
    }
}
